import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function BBLHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-245">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/uCmdo7XTBdcLagM91oveYY/BBL-broadband-light.jpg)'
    }} data-id="element-246" />
      <div className="absolute inset-0 bg-black/60" data-id="element-247" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-248">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-249">
          <div className="mb-6" data-id="element-250">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-251">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-252">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-253">
            Be AMAZING
          </span>

          <h1 className="text-[30px] sm:text-5xl lg:text-[60px] uppercase text-white tracking-tight font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-254">
            BBL FOREVER YOUNG
          </h1>
          <h2 className="text-[26px] sm:text-4xl lg:text-[48px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-255">
            + FOREVER CLEAR
          </h2>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-256">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-257">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-258">
              For a polished look with a radiant glow, it's hard to beat BBL
              (broadband light). In fact, our Medical Director at Be CLINICAL,
              Dr. Fiona, loves having this treatment done.
            </p>

            <div className="border-l-2 border-[#FF1493] pl-6" data-id="element-259">
              <p className="text-[#D0D0D0] text-base leading-[1.7] font-body italic" data-id="element-260">
                "I'm in LOVE with BBL! I get one done every two months and it
                makes my skin radiant! Even more importantly, a Stanford
                University Study showed that Sciton BroadBand Light (BBL™)
                treatments can change the expression of genes associated with
                the aging process to more closely resemble young skin. People
                who get these done regularly have much younger looking skin!"
              </p>
              <p className="text-[#999999] text-sm font-body mt-3" data-id="element-261">
                — Dr. Fiona
              </p>
            </div>

            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-262">
              If you want a refreshed, rejuvenated look with little to no
              downtime, today's BBL treatment is the most revolutionary
              technology in medical aesthetics. Come and try for yourself!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-263">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}